import moment from "moment"
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetWelcomeListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    selectedCustomer: CustomSingleSelectModel | undefined
    selectedSupplier: CustomSingleSelectModel | undefined
    selectedVehicle: CustomSingleSelectModel | undefined
    selectedTrailer: CustomSingleSelectModel | undefined
    selectedDriver: CustomSingleSelectModel | undefined
    selectedWelcomeStatuss: CustomMultiSelectModel[]
    isIn: boolean
    isOut: boolean
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetWelcomeListPagingAndFilterRequest: GetWelcomeListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    selectedCustomer: undefined,
    selectedSupplier: undefined,
    selectedVehicle: undefined,
    selectedTrailer: undefined,
    selectedDriver: undefined,
    // İşlem Durumu varsayılanı artık kolon filtresinde (CommonWelcomeList açılışta kurar).
    selectedWelcomeStatuss: [],
    isIn: false,
    isOut: false,
    columnFilters: []
}